document.querySelectorAll('section').forEach((section) => {
    const buttons = section.querySelectorAll('.product-list-title');
    const listContainers = section.querySelectorAll('.list-container');

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const blockId = button.dataset.blockId;

            // Toggle active state for list containers within the same section
            listContainers.forEach((column) => {
                if (column.dataset.blockId === blockId) {
                    column.classList.add('is-active');
                } else {
                    column.classList.remove('is-active');
                }
            });

            // Toggle active state for product list titles within the same section
            buttons.forEach((title) => {
                if (title.dataset.blockId === blockId) {
                    title.classList.add('is-active');
                    const container = title.parentElement;
                    const buttonWidth = title.offsetWidth;
                    const containerWidth = container.offsetWidth;
                    const buttonPosition = title.offsetLeft;
                    const scrollPosition = buttonPosition - (containerWidth / 2) + (buttonWidth / 2);

                    container.scrollTo({
                        left: scrollPosition,
                        behavior: 'smooth',
                    });
                } else {
                    title.classList.remove('is-active');
                }
            });
        });
    });
});
